/* Minimal AJAX Cart Drawer */
(function () {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  const trackReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const els = {
    overlayClose: drawer.querySelectorAll('[data-cart-drawer-close]'),
    list: drawer.querySelector('[data-cart-items]'),
    body: drawer.querySelector('[data-cart-drawer-body]'),
    empty: drawer.querySelector('[data-cart-empty]'),
    footer: drawer.querySelector('[data-cart-footer]'),
    subtotal: drawer.querySelector('[data-cart-subtotal]'),
    tpl: document.getElementById('cart-drawer-item')
  };

  const money = (cents) =>
    (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.theme && theme.moneyFormat ? theme.moneyFormat : '${{amount}}')
      : `$${(cents / 100).toFixed(2)}`;

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
  }
  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
  }

  els.overlayClose.forEach(btn => btn.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  async function changeQty(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return res.json();
  }

  function renderCart(cart) {
    els.list.innerHTML = '';
    if (!cart.items.length) {
      els.empty.hidden = false;
      els.footer.hidden = true;
      return;
    }
    els.empty.hidden = true;
    els.footer.hidden = false;

    cart.items.forEach((item) => {
      const li = els.tpl.content.firstElementChild.cloneNode(true);
      li.dataset.key = item.key;
      const aImg = li.querySelector('.cart-item__image');
      const img = li.querySelector('img');
      const title = li.querySelector('.cart-item__title');
      const options = li.querySelector('[data-options]');
      const input = li.querySelector('.qty__input');
      const minus = li.querySelector('[data-qty-minus]');
      const plus = li.querySelector('[data-qty-plus]');
      const remove = li.querySelector('[data-remove]');
      const linePrice = li.querySelector('[data-line-price]');

      aImg.href = item.url;
      img.src = (item.image ? item.image : '//cdn.shopify.com/s/images/admin/no-image-compact.gif');
      img.alt = item.product_title;
      title.textContent = item.product_title;
      title.href = item.url;

      // options
      options.innerHTML = '';
      if (item.options_with_values && item.options_with_values.length) {
        options.innerHTML = item.options_with_values.map(o => `<div><strong>${o.name}:</strong> ${o.value}</div>`).join('');
      }

      input.value = item.quantity;
      linePrice.textContent = money(item.final_line_price);

      minus.addEventListener('click', async () => {
        const q = Math.max(0, parseInt(input.value, 10) - 1);
        const updated = await changeQty(item.key, q);
        renderCart(updated);
      });
      plus.addEventListener('click', async () => {
        const q = parseInt(input.value, 10) + 1;
        const updated = await changeQty(item.key, q);
        renderCart(updated);
      });
      input.addEventListener('change', async () => {
        const q = Math.max(0, parseInt(input.value || '0', 10));
        const updated = await changeQty(item.key, q);
        renderCart(updated);
      });
      remove.addEventListener('click', async () => {
        const updated = await changeQty(item.key, 0);
        renderCart(updated);
      });

      els.list.appendChild(li);
    });

    els.subtotal.textContent = money(cart.total_price);

    // Keep scroll position sane
    if (!trackReducedMotion) els.body.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Intercept product forms (add-to-cart)
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    const data = new FormData(form);
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const cart = await getCart();
      renderCart(cart);
      openDrawer();
    } catch (err) {
      console.error('Add to cart failed', err);
    }
  });

  // Optional: capture clicks on “Open cart” icon if you have one
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-open-cart-drawer]');
  if (!btn) return;

  // Optionally detect screen size
  const isMobile = window.innerWidth <= 768;

  if (isMobile) {
    window.location.href = '/cart';
  } else {
    e.preventDefault();
    getCart().then(renderCart);
    openDrawer();
  }
});

  // Initialize (keeps in sync if customer lands on page with items)
  getCart().then(renderCart);
})();